// Section 17: priority group 'Guards'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function guards(_config: Config) {
  return definePriorityGroup({
    id: 'guards',
    label: 'Guards',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter((p) => p.job === 'guard')
        .map((p) => p.id),
  });
}
